<template>
  <div class="columns is-multiline">
    <div class="column is-2">
      <aside class="menu menu--admin is-sticky-position">
        <ul class="menu-list has-background-white is-border">
          <li :class="{'is-active':['ContratDeReservation', 'Financement', 'Notaire', 'Signature'].includes($route.name)}">
            <router-link :to="{name: 'ContratDeReservation', params: {id: adv.pk}}">
              Suivi de vente
            </router-link>
            <ul>
              <li
                v-if="followUpNoteCanToggle && (plan.adv_enabled && adv.promoteur.plan.adv_enabled)"
                style="background-color: #d4e9f1">
                <a
                  class="is-padding-top-small is-padding-bottom-small is-padding-left-large is-paddingless-right"
                  style="min-height: 0"
                  @click="openNoteDeSuivi()">
                  <div class="is-uppercase is-size-7 has-text-black">
                    <!--<span v-if="displayFollowUpNote">Masquer</span><span v-else>Afficher</span> -->
                    afficher note(s) de suivi
                    <!-- <span class="is-padding-left-xsmall"><i class="fas fa-comment-alt"></i></span>-->
                  </div>
                </a>
              </li>
              <li :class="{'is-active' : $route.name === 'ContratDeReservation'}">
                <router-link :to="{name: 'ContratDeReservation', params: {id: adv.pk}}">
                  <div class="is-uppercase">
                    Dossier de réservation
                  </div>
                </router-link>
              </li>
              <li
                v-if="canSign"
                :class="{'is-active' : $route.name === 'Signature'}">
                <router-link :to="{name: 'Signature', params: {id: adv.pk}}">
                  <div class="is-uppercase">
                    Signature
                  </div>
                </router-link>
              </li>
              <li
                v-if="(isReserved || isSold) && adv.lot_data.nature === 'field'"
                :class="{'is-active' : $route.name === 'Construction'}">
                <router-link :to="{name: 'Construction', params: {id: adv.pk}}">
                  <div class="is-uppercase">
                    Construction
                  </div>
                </router-link>
              </li>
              <li
                v-if="isReserved || isSold"
                :class="{'is-active' : $route.name === 'Financement'}">
                <router-link :to="{name: 'Financement', params: {id: adv.pk}}">
                  <div class="is-uppercase">
                    Financement
                  </div>
                </router-link>
              </li>
              <li
                v-if="isReserved || isSold"
                :class="{'is-active' : $route.name === 'Notaire'}">
                <router-link :to="{name: 'Notaire', params: {id: adv.pk}}">
                  <div class="is-uppercase">
                    Acte de vente
                  </div>
                </router-link>
              </li>
            </ul>
          </li>
          <li
            v-if="(isReserved || isSold) && !userIsAnonymous && isPromoteur && isAdmin"
            :class="{'is-active':['Commercialisation', 'SellerFacturation'].includes(this.$route.name)}">
            <router-link :to="{name: 'Commercialisation', params: {id: adv.pk}}">
              Rémunération vendeur
            </router-link>
          </li>
          <li
            v-if="(isReserved || isSold) && isPromoteur && isAdmin && !(adv.lot_data.nature === 'field')"
            :class="{'is-active':$route.name === 'ChoixEtTma'}">
            <router-link :to="{name: 'ChoixEtTma', params: {id: adv.pk}}">
              Choix et TMA
            </router-link>
          </li>
          <li
            v-if="isPromoteur && isAdmin && (isReserved || isSold) && !programIsDeleted && !lotIsDeleted"
            :class="{'is-active':$route.name === 'AppelDeFonds'}">
            <router-link :to="{name: 'AppelDeFonds', params: {id: adv.pk}}">
              Appel de fonds
            </router-link>
          </li>
          <li
            v-if="(isPromoteur && isAdmin || currentUser.active_all_contact) && (isReserved || isSold) && !programIsDeleted && !lotIsDeleted && adv.lot_data.nature === 'field'"
            :class="{'is-active':$route.name === 'Livraison'}">
            <router-link :to="{name: 'Livraison', params: {id: adv.pk}}">
              Livraison
            </router-link>
          </li>
        </ul>
      </aside>
    </div>
    <div
      class="column"
      style="position:relative;">
      <router-view
        :ref="$route.name"
        :sale="sale"
        :seller="seller"
        :lot="lot"
        :program="program" />
      <div
        v-if="canEdit && pendingSubmit"
        class="formActionsSticky is-bottom is-zindex-2">
        <submit-sticky-buttons
          :cancel="appelCancel"
          button-id="feuilleDeRoute"
          :submit-text="'Enregistrer'"
          :loading="submitLoading"
          @submit="updateAdv" />
      </div>
    </div>
    <div
      v-if="displayFollowUpNote && (plan.adv_enabled && adv.promoteur.plan.adv_enabled)"
      class="column is-3 is-margin-left">
      <div style="position: sticky; top: 70px">
        <div class="is-padding-right is-padding-top-xxsmall has-background-white is-border-top is-border-right is-border-left columns is-gapless is-vcentered is-marginless-bottom">
          <div
            @click="isNoteSuivi = true"
            :style="isNoteSuivi ? 'border-bottom: 3px solid black' : 'padding-bottom: 2.8px'"
            style="min-width: 130px; cursor: pointer; justify-content: center; align-items: center; position: relative"
            class="is-flex is-nowrap has-text-centered">
            <div
              style="padding: 10.5px 12px 10.5px"
              class="title is-6 has-text-weight-normal is-uppercase">
              Note(s) de suivi ({{ notesFilter.length }})
            </div>
          </div>
          <div
            @click="isNoteSuivi = false"
            :style="!isNoteSuivi ? 'border-bottom: 3px solid black;' : 'padding-bottom: 3px'"
            style="justify-content: center; align-items: center; cursor: pointer "
            class="is-flex is-nowrap has-text-centered">
            <div
              class="title is-6 has-text-weight-normal is-uppercase is-padding-right-xsmall is-padding-left is-padding-top-xxsmall is-padding-bottom-xxsmall"
              style="height: 100%; margin-bottom: 0; border-left: 1px solid #808080">
              Rappel ({{ reminderForAdv.length }})
            </div>
            <div
              class="is-flex-center is-padding-xsmall"
              style="height: 100%"
              :style="true ? 'background-color: white' : 'background-color:red'">
              <i
                v-if="true"
                class="fal fa-alarm-clock"
                style="color: black">
              </i>
              <i
                v-else
                class="fal fa-alarm-exclamation"
                style="color: white"></i>
            </div>
          </div>
        </div>
        <div v-if="isNoteSuivi">
          <button
            type="submit"
            style="justify-content: flex-start; border-radius: 0px; border-color: #ebebeb"
            class="button is-secondary is-xsmall is-fullwidth is-padding-left-small is-padding-top is-padding-bottom"
            :disabled="openWysi !== null || adv.status==='canceled'"
            @click="openWysi = 'new'">
            <span
              style="font-size: 12px"
              class="is-uppercase">Créer note de suivi</span>
          </button>
        </div>
        <!-- RAPPEL ONGLET -->
        <div v-else>
          <button
            type="submit"
            style="justify-content: flex-start; border-radius: 0px; border-color: #ebebeb;"
            class="button is-secondary is-xsmall is-fullwidth is-padding-left-small is-padding-top is-padding-bottom"
            @click="openReminderCreation()">
            <span
              style="font-size: 12px"
              class="is-uppercase">Créer Rappel</span>
          </button>
        </div>
        <!-- RAPPEL -->
        <div
          class="is-flex"
          v-if="!isNoteSuivi"
          style="height: 100%; min-height: 100%; width: 100%; flex-direction: column">
          <div
            v-for="remind in reminderForAdv"
            :key="remind.pk"
            class="is-flex"
            style="width: 100%">
            <!-- HORLOGE -->
            <div
              class="is-flex-center is-border is-padding-left-small is-padding-right-small is-padding-top is-padding-bottom"
              style=""
              :style="isRemindInFuture(remind.date)? 'background-color: white' : 'background-color:red'">
              <i
                v-if="isRemindInFuture(remind.date)"
                class="fal fa-alarm-clock"
                style="color: black">
              </i>
              <i
                v-else
                class="fal fa-alarm-exclamation"
                style="color: white"></i>
            </div>
            <!-- ELEMS -->
            <div
              style="flex-direction: column; width: 100%"
              class="is-flex">
              <div
                style="background-color: #FCFCFC; justify-content: space-between; min-height: 80px"
                class="is-fullwidth is-border-top is-border-bottom is-border-right is-flex is-nowrap">
                <div
                  style="justify-content: center; flex-direction: column; flex-shrink: 2"
                  class="is-padding-left-small is-flex is-size-6">
                  <span class="is-flex is-wrap-flex">De:
                    &nbsp;
                    <b>{{ remind.author.pk === currentUser.pk ? 'Vous' : `${remind.author.first_name} ${remind.author.last_name}` }}</b>&nbsp;/ Pour:&nbsp;
                    <b>
                      {{ remind.user.pk === currentUser.pk ? 'Vous' : `${remind.user.first_name} ${remind.user.last_name}` }}
                    </b>
                  </span>
                  <span class="is-flex is-wrap-flex">Echéance :&nbsp;<b>{{ remind.date | prettyDate }} à {{ remind.date | prettyTime }}</b></span>
                </div>
                <div
                  class="is-flex"
                  style="background-color: white; flex-shrink: 0">
                  <div
                    @click="updateReminder(remind)"
                    style="min-width: 40px; cursor: pointer"
                    class="update-hover is-flex-center is-border-left is-border-right is-padding-left-small is-padding-right-small is-padding-top-xxsmall is-padding-bottom-xxsmall">
                    <i class="far fa-pen"></i>
                  </div>
                  <!-- <div
                    style="min-width: 40px; cursor: pointer"
                    class="is-flex-center is-border is-padding-left-small is-padding-right-small is-padding-top-xxsmall is-padding-bottom-xxsmall">
                    <i class="far fa-check"></i>
                  </div> -->
                  <div
                    @click="deleteReminder(remind)"
                    style="min-width: 40px; cursor: pointer"
                    class="delete-hover is-flex-center is-padding-left-small is-padding-right-small is-padding-top-xxsmall is-padding-bottom-xxsmall">
                    <i class="far fa-trash"></i>
                  </div>
                </div>
              </div>
              <div
                style="background-color: #FFFFFF; min-height: 80px"
                class="is-fullwidth is-border-bottom is-border-right is-flex is-padding-top-small is-padding-bottom-small is-padding-right-xxsmall">
                <div
                  style="justify-content: center"
                  class="is-padding-left-small is-flex is-column is-size-6">
                  <div class="is-flex">
                    <div class="has-text-weight-bold">
                      Objet:&nbsp;
                    </div>
                    {{ remind.title }}
                  </div>
                  <div class="is-flex">
                    <!-- <span style="width: 100%; height: auto">Détails:&nbsp;</span>
                    <div v-html="remind.note"></div> -->
                    <div v-html="`<b>Détails :</b> ${remind.note || ''}`"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Note de suivi  -->
        <div
          v-else-if="openWysi == 'new' && isNoteSuivi"
          class="is-border has-background-white">
          <contact-note
            :source="{message: ''}"
            @deleteNote="deleteNote"
            @close="noteClose"
            @save="noteSave" />
        </div>
        <div
          v-if="notesFilter && notesFilter.length && isNoteSuivi"
          class="has-background-white is-padding is-border-left is-border-right">
          <div
            v-for="(note) in notesFilter"
            :key="note.pk"
            class="vadDiscussion">
            <div
              v-if="note.pk !== openWysi"
              class="vadDiscussion--bulle is-size-6"
              :class="{'is-classic': note.user.pk != currentUser.pk}">
              <div
                class="content is-break-word"
                v-html="note.message" />
            </div>
            <contact-note
              v-else
              :source="note"
              class="is-border"
              @deleteNote="deleteNote"
              @close="noteClose"
              @save="noteSave" />
            <div class="level">
              <div class="level-left">
                <div class="is-size-7">
                  <div><b>Date : </b>{{ note.created_on | prettyDate }}</div><!-- prettyDate -->
                  <div v-if="note.user">
                    <b>Auteur : </b>{{ note.user.last_name }} {{ note.user.first_name }}
                  </div>
                </div>
              </div>
              <div class="level-right">
                <button
                  v-if="note.user.pk == currentUser.pk"
                  type="submit"
                  class="button is-white is-border is-rounded is-xsmall"
                  :disabled="openWysi !== null || adv.status==='canceled'"
                  @click="openWysi = note.pk">
                  <span class="icon is-small"><i class="fas fa-marker" /></span>
                  <span>Modifier note</span>
                </button><!-- @click="openNoteQuickview({ item: Object.assign({}, note) })" -->
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="!notes.length && openWysi === null && isNoteSuivi"
          class="has-background-white is-padding-right is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall is-border-left is-border-top is-border-right">
          <span class="is-size-6"><i>Aucune note de suivi</i></span>
        </div>
        <div
          v-if="notes.length > notesCompactMode && isNoteSuivi"
          class="is-border">
          <button
            class="button is-light is-small is-fullwidth is-padding-left"
            @click="toggleNotes()">
            <div
              v-if="notesFilter.length < notes.length"
              class="w100 has-text-left">
              <span class="icon"><i class="far fa-chevron-down" /></span>
              <span>{{ notes.length - notesFilter.length }} notes supplémentaires</span>
            </div>
            <div
              v-else
              class="w100 has-text-left">
              <span class="icon"><i class="far fa-chevron-up" /></span>
              <span>Masquer notes anciennes</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Adv } from '@/mixins'
import Vue from 'vue'
import moment from 'moment'
Vue.prototype.moment = moment

export default {
  name: 'FeuilleDeRoute',
  components: {
    ContactNote: () => import('../../contacts/ContactRightPanel/ContactNote')
  },
  mixins: [Adv],
  data () {
    return {
      openWysi: null, // PK du commentaire à ouvrir ou 'new' pour un nouveau commentaire
      viewAllNotes: false,
      notesCompactMode: 5, // Nombre de notes affichées en compact mode
      notes: [],
      openAllNotes: false,
      displayFollowUpNote: true,
      wWidth: null,
      isNoteSuivi: true,
      reminderForAdv: []
    }
  },
  computed: {
    notesFilter () {
      if (this.viewAllNotes) return this.notes
      return this.notes.filter((el, i) => {
        return i < this.notesCompactMode
      })
    },
    /**
       * can sign
       * @returns {boolean}
       */
    canSign () {
      return (this.isAdmin && this.isPromoteur) || (!(this.isAdmin && this.isPromoteur) && this.adv.use_electronic_signature && !this.adv.signature_date)
    },
    followUpNoteCanToggle () {
      // Si on peut toggle les notes de suivi
      if (this.followUpNoteIsForbidden) {
        return false
      } else if ((this.isAdmin) && this.wWidth < 1280) {
        return true
      } else if (!(this.isAdmin)) {
        return true
      } else {
        return false
      }
    },
    followUpNoteIsForbidden () {
      // Ici les cas de figures ou les notes sont interdites
      // Page ou les notes ne sont pas visibles
      if (['Commercialisation', 'ChoixEtTma', 'AppelDeFonds', 'SellerFacturation'].includes(this.$route.name) === true) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name !== from.name) {
        this.verifDisplayFollowUpNote()
      }
    }
  },
  created () {
    this.getNotes()
    this.getReminder()
  },
  mounted () {
    this.calculReSizesScreen()
    window.addEventListener('resize', this.calculReSizesScreen)
  },
  destroyed () {
    window.removeEventListener('resize', this.calculReSizesScreen)
  },
  methods: {
    async getNotes () {
      try {
        let { data } = await this.$api.get(`/reservations/${this.advPk}/notes`)
        this.notes = data.items
      } catch (err) {
        console.log(err)
      }
    },
    async deleteNote (note) {
      try {
        await this.$api.delete(`/reservations/${this.advPk}/notes`, note.pk)
        this.getNotes()
        this.noteClose()
      } catch (err) {
        console.log(err)
      }
    },
    noteSave (note) {
      if ('pk' in note && note.pk) {
        this.editNote(note)
      } else {
        this.createNote(note)
      }
      this.noteClose()
    },
    async editNote (note) {
      try {
        await this.$api.put(`/reservations/${this.advPk}/notes`, note.pk, note)
        this.getNotes()
      } catch (err) {
        console.log(err)
      }
    },
    async createNote (note) {
      try {
        await this.$api.post(`/reservations/${this.advPk}/notes`, note)
        this.getNotes()
      } catch (err) {
        console.log(err)
      }
    },
    toggleNotes () {
      this.viewAllNotes = !this.viewAllNotes
    },
    noteClose () {
      this.openWysi = null
    },
    openNoteDeSuivi () {
      let params = {
        source: this.advPk
      }
      this.$store.commit('setQuickview', { mode: 'NOTES_LIST', params })
    },
    calculReSizesScreen () {
      this.wWidth = window.innerWidth
      this.verifDisplayFollowUpNote()
    },
    verifDisplayFollowUpNote () {
      // Verification si les notes sont visible ou non
      if (this.followUpNoteIsForbidden) {
        this.displayFollowUpNote = false // ON masque les notes si l'affichage y est interdit
        return true
      } else if ((this.isAdmin || this.isSectorManager) && this.followUpNoteCanToggle) {
        this.displayFollowUpNote = false // ON masque les notes
      } else if (!(this.isAdmin || this.isSectorManager)) {
        this.displayFollowUpNote = false // ON masque les notes automatiquement si on est pas admin
      } else {
        this.displayFollowUpNote = true
      }
    },
    async openReminderCreation () {
      let params = {
        noRedirection: true,
        type: 'onlyReminder',
        source: {
          advLink: this.adv.pk,
          programLink: this.adv.program.pk,
          programName: this.adv.program.name,
          advRef: this.adv.ref
        }
      }
      await this.openCalendarNewActionContact(params)
      await this.getReminder()
    },
    async updateReminder (remind) {
      let params = {
        noRedirection: true,
        source: remind,
        type: 'onlyReminder'
      }
      await this.openCalendarNewActionContact(params)
      await this.getReminder()
    },
    async deleteReminder (remind) {
      let r = await this.confirmDelete()
      if (r.value) {
        let eventPk = remind.pk
        let key = moment(remind.date).format('DD/MM/YYYY')
        try {
          await this.$api.delete(this.$resources.REMINDER, eventPk)
          this.$store.commit('removeCalendarEvent', { eventPk, key, type: 'reminders' })
          this.getReminder()
          this.$toasted.global.success('Le rappel à été supprimé.')
        } catch (err) {
          console.log(err)
          this.handleError(err)
        }
      }
    },
    confirmDelete () {
      return this.$swal({
        title: 'Suppression rappel',
        text: 'Le rappel ne sera plus consultable.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    openCalendarNewActionContact (params) {
      return new Promise((resolve) => {
        this.$store.commit('setQuickview', { mode: 'NEW_CALENDAR_ACTION', params, resolve })
      })
    },
    isRemindInFuture (date) {
      const dateFortest = moment(date).add(2, 'hours').toDate()
      return moment().isBefore(dateFortest)
    },
    async getReminder () {
      let params = {
        custom_fields: `adv_ref:${this.adv.ref}`
      }
      const result = await this.$api.get(this.$resources.REMINDER, params)
      this.reminderForAdv = result.data.items
    }
  }
}

</script>
